module.exports = __webpack_public_path__ + "img/banner.aa70781f.jpg";